import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { BigNumber } from 'bignumber.js';

export default async (tokenAddress: Ref<string | string>) => {
  const { address } = useWeb3ModalAccount();
  const { availableTokens } = useTokensReader();
  const balance = ref<string>();
  const isLoading = ref(false);

  const pullBalance = async (address: string, tokenAddress: string) => {
    try {
      isLoading.value = true;

      if (!tokenAddress) {
        return;
      }
      const balanceToken = await availableTokens(address, tokenAddress);

      balance.value = new BigNumber(balanceToken).toFixed(2, BigNumber.ROUND_FLOOR);
    } finally {
      isLoading.value = false;
    }
  };

  watch(
    [address, tokenAddress],
    async ([addressValue, tokenAddressValue]) => {
      if (!addressValue || !tokenAddress) return;

      await pullBalance(addressValue, tokenAddressValue);
    },
    {
      immediate: true
    }
  );

  return {
    balance,
    isLoading,
    pullBalance
  };
};
